import { ApiKeysSection } from '@/components/api-keys/ApiKeysSection'

/**
 * The signed-in person's own settings. Everything here is about the reader:
 * `/users/me/api-keys` is scoped to the caller, so the page needs no role gate.
 */
export function SettingsPage() {
	return (
		<div className="space-y-6">
			<div>
				<h1 className="text-2xl font-bold text-ds-text">Settings</h1>
				<p className="text-sm text-ds-text-muted mt-1">Manage your account settings and preferences</p>
			</div>

			<ApiKeysSection />
		</div>
	)
}
